import { render, staticRenderFns } from "./ViewerNotice.vue?vue&type=template&id=277303fd&scoped=true"
import script from "./ViewerNotice.vue?vue&type=script&lang=js"
export * from "./ViewerNotice.vue?vue&type=script&lang=js"
import style0 from "./ViewerNotice.vue?vue&type=style&index=0&id=277303fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277303fd",
  null
  
)

export default component.exports